import { Fade } from "react-awesome-reveal";
import "./contacts-find-us.scss";

const ContactsFindUs = () => {
  return (
    <section className="contacts-find-us">
      <Fade
        direction="up"
        duration={800}
        triggerOnce
        style={{ display: "flex", justifyContent: "center" }}
      >
        <h2 className="contacts-find-us__title">Trovaci</h2>
      </Fade>
      <Fade
        direction="up"
        duration={1000}
        delay={200}
        triggerOnce
        style={{ display: "flex", justifyContent: "center" }}
      >
        <p className="contacts-find-us__text">
          Con più di 20 anni di attività nel campo, possiamo garantirvi il
          massimo risultato rassicurandovi interventi eseguiti ad opera d'arte.
        </p>
      </Fade>
    </section>
  );
};

export default ContactsFindUs;
